module.exports = fox._r("images/promo/heart.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/heart.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/heart.png
// module id = 169
// module chunks = 2